import React from 'react';

const SearchBar = ({ searchTerm, onSearchTermChange, onSearchClick, disabled }) => (
  <div className="option-section-search-container">
    <div className="option-section-search-bar">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={onSearchTermChange}
        onKeyDown={e => { if (e.key === 'Enter') onSearchClick(); }}
        maxLength={50}
        disabled={disabled}
        className="option-section-search-bar__input"
      />
    </div>
    <button onClick={onSearchClick} disabled={disabled} className="option-section-search-button">
      Search
    </button>
  </div>
);
export default SearchBar;
